<template>
  <div>
    <div v-if="end !== null && commitment === 0" class="date-icon">
      <v-tooltip bottom v-if="!onlyIcon">
        <span :style="(isFinalized ? 'text-decoration: line-through;' : '') + (isMobileDesign ? 'font-size: 11px;' : '')" slot="activator">{{ end ? ((moment().diff(moment(end), 'days') > 0) ? moment(end).locale('pt-br').format('L') : moment(end).locale('pt-br').calendar()) : '' }}</span>
        <span>Data de previsão</span>
      </v-tooltip>
      <span>
        <v-tooltip v-if="isFinalized" bottom>
          <v-icon slot="activator" color="green" size=20>check_circle</v-icon>
          <span>Atividade concluída {{moment(status_date).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
        <v-tooltip v-else-if="end && (moment(end).diff(moment(), 'seconds') < -60)" bottom>
          <v-icon slot="activator" color="red" size=20>cancel</v-icon>
          <span>Atividade atrasada {{moment(end).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
        <v-tooltip v-else-if="end" bottom>
          <v-icon  slot="activator" color="blue" size=20>lens</v-icon>
          <span>Atividade vencerá {{moment(end).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
      </span>
    </div>
    <div v-else-if="begin !== null && commitment === 1" class="date-icon mx-2">
      <v-tooltip bottom v-if="!onlyIcon">
        <span :style="(isFinalized ? 'text-decoration: line-through;' : '') + (isMobileDesign ? 'font-size: 11px;' : '')" slot="activator">{{ begin ? ((moment().diff(moment(begin), 'days') > 0) ? moment(begin).locale('pt-br').format('L') : moment(begin).locale('pt-br').calendar()) : '' }}</span>
        <span>Data de inicio</span>
      </v-tooltip>
      <span>
        <v-tooltip v-if="isFinalized" bottom>
          <v-icon  slot="activator" color="green" size=20>event_available</v-icon>
          <span>Compromisso concluído {{moment(status_date).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
        <v-tooltip v-else-if="moment(begin).diff(moment(), 'seconds') < 0 && moment(end).diff(moment(), 'seconds') > 60" bottom>
          <v-icon slot="activator" color="green" size=18>calendar_today</v-icon>
          <span>Compromisso iniciado {{moment(begin).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
        <v-tooltip v-else-if="begin && (moment(begin).diff(moment(), 'seconds') < -60)" bottom>
          <v-icon slot="activator" color="red" size=20>event_busy</v-icon>
          <span>Compromisso iniciado {{moment(begin).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
        <v-tooltip v-else-if="begin" bottom>
          <v-icon  slot="activator" color="blue" size=18>calendar_today</v-icon>
          <span>Compromisso iniciará {{moment(end).locale('pt-br').fromNow()}}</span>
        </v-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  momentDurationFormatSetup(moment)
  export default {
    props: {
      begin: null,
      end: null,
      status_date: null,
      commitment: 0,
      isFinalized: false,
      isMobileDesign: false,
      // onlyIcon MOstra apenas o icone da data exemplo PDependency
      onlyIcon: false
    }
  }
</script>


<style scoped>
  .date-icon {
    height: 24px;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PTaskDateIcon.vue